import { Route, Routes } from 'react-router-dom';
import { RoleEnum } from 'src/types';
import {
  // AccountConfirmation,
  // AccountConfirmed,
  AccountNotActivated,
  AccountNotActive,
  AddCampaign,
  AddDevice,
  AddInteraction,
  AddTheme,
  Branding,
  Brandings,
  Campaign,
  Campaigns,
  Dashboard,
  DevelopmentPreview,
  Device,
  Interaction,
  Interactions,
  Login,
  NotFound,
  // PasswordRecovery,
  // PasswordReset,
  // PasswordResetSuccess,
  // Register,
  ThemeDetails,
  ThemesList,
  Unauthorized,
} from 'src/views';
import { EditCampaign } from 'src/views/campaign/edit';
import { AddBranding } from 'src/views/branding/add';
import { Devices } from 'src/views/device/list';
import {
  AddInteractionDictionary,
  InteractionDictionary,
  InteractionDictionaryItem,
} from 'src/views/interaction-dictionary';

import {
  LoggedInRoutesGuard,
  LoggedOutRoutesGuard,
} from './guards';
import { routes } from './routes';

export const Router = () => {
  return (
    <Routes>
      <Route path="*" element={<NotFound />} />
      <Route path={routes.accountUnauthorized} element={<Unauthorized />} />
      <Route
        path={routes.accountNotActivated}
        element={<AccountNotActivated />}
      />
      <Route path={routes.accountNotActive} element={<AccountNotActive />} />

      {/* TODO: REMOVE DEVELOPMENT PREVIEW ROUTE */}
      <Route
        path={routes.developmentPreview}
        element={<DevelopmentPreview />}
      />


        {/* PUBLIC ROUTES - Redirect to dashboard if logged in */}
        <Route element={<LoggedOutRoutesGuard />}>
          {/* <Route path={routes.register} element={<Register />} /> */}
          <Route path={routes.login} element={<Login />} />
          {/* <Route
            path={routes.accountConfirmation}
            element={<AccountConfirmation />}
          />
          <Route
            path={routes.accountConfirmed}
            element={<AccountConfirmed />}
          />
          <Route
            path={routes.passwordRecovery}
            element={<PasswordRecovery />}
          />
          <Route path={routes.passwordReset} element={<PasswordReset />} />
          <Route
            path={routes.passwordResetSuccess}
            element={<PasswordResetSuccess />}
          /> */}
        </Route>

        {/* PROTECTED ROUTES - Require authentication and authorization */}
        <Route
          element={
            <LoggedInRoutesGuard
              allowedRoles={[
                RoleEnum.ADMIN,
                RoleEnum.SUPER_ADMIN,
                RoleEnum.EDITOR,
              ]}
            />
          }
        >
          {/* DASHBOARD ROUTES */}
          <Route path={routes.dashboard} element={<Dashboard />} />

          {/* DEVICE ROUTES */}
          <Route path={routes.device} element={<Device />} />
          <Route path={routes.devices} element={<Devices />} />
          <Route path={routes.deviceNew} element={<AddDevice />} />

          {/* INTERACTION ROUTES */}
          <Route path={routes.interaction} element={<Interaction />} />
          <Route path={routes.interactions} element={<Interactions />} />
          <Route path={routes.interactionNew} element={<AddInteraction />} />

          {/* INTERACTION DICTIONARY ROUTES */}
          <Route
            path={routes.interactionsDictionary}
            element={<InteractionDictionary />}
          />
          <Route
            path={routes.interactionsDictionaryNew}
            element={<AddInteractionDictionary />}
          />
          <Route
            path={routes.interactionDictionary}
            element={<InteractionDictionaryItem />}
          />

          {/* BRANDING ROUTES */}
          <Route path={routes.branding} element={<Branding />} />
          <Route path={routes.brandings} element={<Brandings />} />
          <Route path={routes.brandingNew} element={<AddBranding />} />

          {/* CAMPAIGN ROUTES */}
          <Route path={routes.campaignEdit} element={<EditCampaign />} />
          <Route path={routes.campaign} element={<Campaign />} />
          <Route path={routes.campaigns} element={<Campaigns />} />
          <Route path={routes.campaignNew} element={<AddCampaign />} />

          {/* THEME ROUTES */}
          <Route path={routes.themes} element={<ThemesList />} />
          <Route path={routes.theme} element={<ThemeDetails />} />
          <Route path={routes.themeNew} element={<AddTheme />} />
        </Route>
    </Routes>
  );
};
